var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 97,
    viewBox: "0 0 96 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7x8ydfpg8a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m84.181 50.907-1.362.282-.845-4.087a2.791 2.791 0 0 0-3.288-2.161l-6.81 1.408-6.198-29.97a5.633 5.633 0 0 0-1.661-2.952 5.563 5.563 0 0 0-4.914-1.37L7.337 22.76a5.565 5.565 0 0 0-4.323 6.576L14 82.464l14.985-3.098a6.956 6.956 0 0 1 13.623-2.817l29.97-6.197a6.956 6.956 0 0 1 13.622-2.816l6.812-1.409-2.254-10.898a5.565 5.565 0 0 0-6.576-4.322z",
    fill: "#FFEB99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.154 18.323c.325-1.587.612-3.223.863-4.894a5.633 5.633 0 0 1 1.662 2.952l.281 1.362-2.806.58zM90.757 55.23l2.253 10.898-6.811 1.408a6.956 6.956 0 0 0-13.623 2.817l-29.97 6.196a6.956 6.956 0 0 0-13.622 2.817l-14.985 3.098-.56-2.711c16.582-7.875 39.585-24.066 48.235-55.259l4.752 22.982 12.26-2.535a2.791 2.791 0 0 1 3.288 2.16l.845 4.088 1.362-.282a5.565 5.565 0 0 1 6.576 4.322z",
    fill: "#FFE477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.96 17.742 5.915 28.608-5.45 1.127-5.35-25.883a2.782 2.782 0 0 1 2.16-3.288l2.725-.564z",
    fill: "#FFC477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2 67.536a6.956 6.956 0 1 1-13.623 2.816A6.956 6.956 0 0 1 86.2 67.536zM42.607 76.55a6.956 6.956 0 1 1-13.623 2.816 6.956 6.956 0 0 1 13.623-2.817z",
    fill: "#787680"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.802 22.531 6.811-1.408 10.703 51.766-6.81 1.408-10.704-51.766z",
    fill: "#FFC477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49.613 21.123 6.812-1.408L67.128 71.48l-6.811 1.408-10.704-51.766z",
    fill: "#FFB655"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.505 74.297 1.127 5.449 13.622-2.817-1.127-5.449-13.622 2.817z",
    fill: "#898890"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.47 29.008 8.173-1.69 5.915 28.607-8.173 1.69-5.915-28.607zM26.455 25.91l8.174-1.69 5.915 28.608-8.174 1.69-5.915-28.608z",
    fill: "#FFC477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.151 76.877 2.725-.563.563 2.724-2.724.564-.564-2.725zM77.744 67.863l2.725-.563.563 2.725-2.724.563-.564-2.725z",
    fill: "#57565C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.47 29.008 1.362-.282 5.915 28.608-1.362.281-5.915-28.607zM26.455 25.91l1.362-.282 5.915 28.608-1.362.282-5.915-28.608zM42.802 22.53l1.362-.282 10.703 51.766-1.362.281L42.802 22.53zM61.95 18.955l5.84 28.24-1.363.281-5.352-25.883c-.2-.973.134-1.978.875-2.638z",
    fill: "#FFB655"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "7x8ydfpg8a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(-11.682 83.701 6.195)",
    d: "M0 0h80.682v80.682H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBus);
export default __webpack_public_path__ + "static/media/bus.1136a5c51dc35c20c19e8c3e1f493072.svg";
export { ForwardRef as ReactComponent };